<script>
export default {
  name: 'EmptyStateSuggestion',
  props: ['id'],
  template: '#empty-state-suggestion-template',
  data: function() {
    return {
      data: {}
    };
  },
  methods: {
    loadData: function() {
      var self = this;
      $.ajax({
        url: '/product_searches/' + this.id + '/suggestions',
        success: function(data) {
          self.data = data;
        }
      });
    },
    searchSuggestion: function(suggestion) {
      // Create a new search with the suggested term
      var form = $('<form>', {
        'method': 'POST',
        'action': '/product_searches'
      });
      
      // Add CSRF token
      var csrfToken = $('meta[name="csrf-token"]').attr('content');
      form.append($('<input>', {
        'type': 'hidden',
        'name': 'authenticity_token',
        'value': csrfToken
      }));
      
      // Add search term
      form.append($('<input>', {
        'type': 'hidden',
        'name': 'product_search[term]',
        'value': suggestion
      }));
      
      // Add quotation_id if present
      var quotationId = $('input[name="product_search[quotation_id]"]').val();
      if (quotationId) {
        form.append($('<input>', {
          'type': 'hidden',
          'name': 'product_search[quotation_id]',
          'value': quotationId
        }));
      }
      
      // Submit form
      $('body').append(form);
      form.submit();
    }
  },
  created: function() {
    this.loadData();
  }
}
</script>